import React, { useState } from 'react'
import AddNewPreventiveCare from './AddNewPreventiveCare';

const PreventiveCare = ({ data, setIsRecordSaved, patientID, ...props }) => {

  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenPreventiveCare, setIsOpenPreventiveCare] = useState(false);
  const [preventiveCareData, setPreventiveCareData] = useState([]);

  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddPreventiveCare = (item) => {
    if(!isViewAllowed) return;
    setPreventiveCareData(item)
    setIsOpenPreventiveCare(prev => !prev);
  }
  const ClosePreventiveCare = () => {
    setIsOpenPreventiveCare(false)
  }

  let PopupScreen = "";
  if (isOpenPreventiveCare) {
    PopupScreen = <AddNewPreventiveCare isOpenPreventiveCare={isOpenPreventiveCare} preventiveCareData={preventiveCareData} setPreventiveCareData={setPreventiveCareData} setIsRecordSaved={setIsRecordSaved} onClose={ClosePreventiveCare} patientID={patientID} // onDeletePreventiveCare={DeletePreventiveCare} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      <div className='mb-2'>
        <div className="d-flex justify-content-between align-items-center mb-1 mx-2">
          <p className='heading cursor-pointer user-select-none' onClick={handleToggleExpand}>Preventive Care</p>
          <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddPreventiveCare({ PatientHistoryID: null })}>
            <i className="icon-dash-plus"></i>
          </div>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
          {expandItems &&
          (data?.length > 0 ?
            data.map(item => (
              <div className='ar-dot'>
                <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddPreventiveCare(item)}>{item.Notes}</p>
              </div>
            )) :
            <p className="text C9-light-clr fst-italic">No preventive care recorded</p>)}
        </div>
      </div>
    </>
  )
}

export default PreventiveCare